import { SchemaCSSStyleSheetDefinition } from './SchemaDefinition'
import { CSSStyleSheetDefinition } from './TypedDefinition'
import { CSSStyleSheetNode } from './TypedNode'
import { CSSStyleSheetModel } from './ViewModel'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface CSSStyleSheetPluginProps {}

export class CSSStyleSheetPlugin implements RehajePlugin {
  props: CSSStyleSheetPluginProps

  visitors: PluginVisitors
  constructor(props?: CSSStyleSheetPluginProps) {
    this.props = { ...props }
    this.visitors = {
      definitions: {
        CSSStyleSheet: CSSStyleSheetDefinition,
        'Schema.CSSStyleSheet': SchemaCSSStyleSheetDefinition
      },
      models: {
        CSSStyleSheet: CSSStyleSheetModel
      },
      nodes: {
        CSSStyleSheet: CSSStyleSheetNode
      }
    }
  }
}
